import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import JobManagement from '../components/Jobs/JobManagement';
import { Navigate } from 'react-router-dom';

const JobsPage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while auth is being checked
  if (isLoading) {
    return (
      <div className="jobs-page-container">
        <div className="loading">Kraunama...</div>
      </div>
    );
  }

  // Redirect if not authenticated or not an employer
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (user?.user_type !== 'employer') {
    return <Navigate to="/" replace />;
  }

  return <JobManagement />;
};

export default JobsPage;
